import { render, staticRenderFns } from "./TablerowBase.vue?vue&type=template&id=42aa06be&scoped=true"
import script from "./TablerowBase.vue?vue&type=script&lang=js"
export * from "./TablerowBase.vue?vue&type=script&lang=js"
import style0 from "./TablerowBase.vue?vue&type=style&index=0&id=42aa06be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aa06be",
  null
  
)

export default component.exports